class TabContent extends HTMLElement {
	constructor() {
		super();
		this.selectors = {
			buttons: '.tab-content__button',
			contents: '.tab-content__content'
		}

		this.elements = {
			buttons: this.querySelectorAll(this.selectors.buttons),
			contents: this.querySelectorAll(this.selectors.contents)
		}

		this.classes = {
			buttonActive: 'tab-content__button--active',
			contentActive: 'tab-content__content--active'
		}

		this.init();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.elements.buttons.forEach(button => {
			button.addEventListener("click", () => {
				this.removeActiveClass();
				this.addActiveClass(button);
			})
		});

		
	}

	removeActiveClass(){
		this.elements.buttons.forEach(button => {
			button.classList.remove(this.classes.buttonActive);
		});

		this.elements.contents.forEach(content => {
			content.classList.remove(this.classes.contentActive);
		})
	}

	addActiveClass(button){
		const blockId = button.dataset.id;

		button.classList.add(this.classes.buttonActive);
		
		this.elements.contents.forEach(content => {
			if (content.dataset.contentId === blockId) {
				content.classList.add(this.classes.contentActive)
			}
		})
	}
}

customElements.define('tab-content', TabContent);
